<template>
    <common-chart :chart-id="chartId" :options="options"></common-chart>
</template>

<script>
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart";

export default {
    name: "OperationRateGauge",
    components: {CommonChart},
    props: {
        chartId: {
            type: String,
            default: 'chart'
        },
        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        options() {
            return {
                tooltip: {
                    formatter: '{b} : {c}%',
                    color: '#eee'
                },
                series: [
                    {
                        name: 'Pressure',
                        type: 'gauge',
                        progress: {
                            show: true
                        },
                        detail: {
                            valueAnimation: true,
                            formatter: '{value}',
                            color: '#eee'
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#ddd',
                            },
                        },
                        axisLabel: {
                            show: false
                        },
                        data: [
                            {
                                value: this.value,
                                name: '作业率',
                                title: {
                                    color: '#ddd'
                                }
                            }
                        ]
                    }
                ]
            }
        }
    }
}
</script>

<style scoped>

</style>